import type { MouseEventHandler } from "react";
import type { TIconKey } from "@/ui/components/primitives/Icon";
import type { TWithDataComponent } from "@/ui/lib/types";
import { type CatActivityLevel, type CatBodyType } from "@/primary-models";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_LIFESTYLE_CARD_ARTICLE_CLASS =
  "w-full rounded-sys-sm border border-component-card-base p-4 shadow-sm shadow-sys-outline-dark bg-white";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatLifestyleCardCat = {
  name: string;
  weight: number | null;
  bodyType: CatBodyType | null;
  lifestyle: CatActivityLevel | null;
  calories: number | null;
  suggestedCalories: number | null;
};

export type TCatLifestyleCardProps = TWithDataComponent & {
  cat: TCatLifestyleCardCat;
  alert?: string;
  onEditHealth: MouseEventHandler<HTMLButtonElement>;
  onEditCalories: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardCaloriesSectionProps = {
  calories: string;
  description: string | null;
  alert?: string;
  title: string;
  editCopy: string;
  editAriaLabel: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardHealthSectionProps = {
  healthStats: TCatLifestyleCardHealthStat[];
  title: string;
  editCopy: string;
  editAriaLabel: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatLifestyleCardHealthStat = {
  icon: TIconKey;
  label: string;
  value: string;
};

export type TUseCatLifestyleCard = {
  healthStats: TCatLifestyleCardHealthStat[];
  healthTitle: string;
  portionSizeTitle: string;
  dailyCalories: string;
  editCopy: string;
  editHealthAriaLabel: string;
  editCaloriesAriaLabel: string;
  caloriesDescription: string | null;
};

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const CAT_LIFESTYLE_CARD_DEFAULTS = {
  "data-component": "CatLifestyleCard",
} as const;
